// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-by-month-chart[data-v-4ea9609c] {\n  height: 300px;\n}", ""]);
// Exports
module.exports = exports;
